import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "parksevice-conatainer"
};
const _hoisted_2 = {
  class: "parkservice-content"
};
const _hoisted_3 = {
  class: "tabs-wrap"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  style: {
    "padding": "8px"
  }
};
import { ref, reactive, onMounted } from 'vue';
import { imageMap, getServerImage } from '@/utils/images';
import Footer from '@/components/footer/index.vue';
import Recreationalvehicle from './components/recreationalvehicle.vue';
import { menus } from '@/api';
export default {
  __name: 'index',
  setup(__props) {
    const activeTab = ref('xuzhi');
    onMounted(() => {
      loadGardenData();
    });
    const loadGardenData = async () => {
      try {
        const {
          data
        } = await menus({
          type: 2
        });
        console.log('load menus', data);
        const addSelects = data.map(item => {
          return {
            ...item,
            isSelect: false
          };
        });
        serviceList.push(...addSelects);
      } catch (error) {}
    };
    const serviceList = reactive([]);
    const handleTabChange = name => {
      console.log('handleTabChange', name);
      serviceList.forEach(item => {
        item.isSelect = item.id === name;
      });
    };
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "news-header",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(imageMap)['servicebge42837b.png']})`
        })
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "header-title-ch"
      }, "游园服务", -1), _createElementVNode("div", {
        class: "header-title"
      }, "GARDEN SERVICE", -1)]))], 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
        active: activeTab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        "title-active-color": "#2bb061",
        color: "#2bb061",
        "line-width": "80px",
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceList, item => {
          return _openBlock(), _createBlock(_component_van_tab, {
            key: item.id,
            name: item.id
          }, {
            title: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("img", {
              src: _unref(getServerImage)(!item.isSelect ? item.icon : item.active_icon),
              alt: item.name,
              height: "30px"
            }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)])]),
            default: _withCtx(() => [_createVNode(Recreationalvehicle, {
              "data-info": item
            }, null, 8, ["data-info"])]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"])])]), _createVNode(Footer)]);
    };
  }
};